// @flow

import styled from 'styled-components';
import { REGULAR } from '../../../helpers/fontWeight';
import type { Theme } from '../../../types';

const PackageTitle = styled<any, Theme>('th')`
  color: ${props => props.theme.packageCompare.packageTitle.color};
  font-size: ${props => props.theme.packageCompare.packageTitle.fontSize};
  font-weight: ${REGULAR};
  line-height: 2rem;
  padding-bottom: 0.875rem;
`;

export default PackageTitle;
